import autoTable from "jspdf-autotable";
import { NUM, fmtDate, todayISO, unitLabel } from "@/lib/format";
import { createDoc, partyLines, money, NAVY, INK, TEXT, SLATE, BAND, GREEN, RED } from "@/lib/docPdf";

/** Cari Ekstre PDF — faturalar, cari ürün girişleri ve tahsilatlar; çalışan bakiye. stmt: GET /contacts/{id}/statement */
export async function buildStatementPdf({ stmt, showItems = false }) {
  const c = stmt.contact || {};
  const today = fmtDate(todayISO());
  const period = (stmt.start || stmt.end) ? `${stmt.start ? fmtDate(stmt.start) : "Başlangıç"} – ${stmt.end ? fmtDate(stmt.end) : today}` : "Tüm kayıtlar";
  const D = await createDoc({ title: "CARİ EKSTRE", subtitle: "HESAP HAREKETLERİ", contLine: `${c.title || ""}  ·  ${period}  ·  devam` });
  const { pdf, F, T, M, W, HEAD1 } = D;
  D.header(1);
  const rowH = D.partyCard(HEAD1 + 5, { name: c.title || "", lines: partyLines(c), meta: [["BELGE TARİHİ", today], ["DÖNEM", period]] });

  const opening = Number(stmt.opening || 0);
  const body = [];
  if (opening) body.push(["—", "Devir Bakiyesi", "", "", money(opening)]);
  (stmt.rows || []).forEach((r) => {
    const subs = showItems ? (r.items || []).filter((it) => String(it.name || "").trim()).map((it) => {
      const net = Number(it.unit_price || 0) * (1 - Number(it.discount_rate || 0) / 100);
      return `• ${it.name} — ${NUM(it.quantity)} ${unitLabel(it.unit)} × ${money(net)} = ${money(Number(it.quantity || 0) * net)}`;
    }) : [];
    body.push([fmtDate(r.date), [r.label, ...subs].join("\n"), r.amount > 0 ? money(r.amount) : "", r.amount < 0 ? money(-r.amount) : "", money(r.balance)]);
  });
  autoTable(pdf, D.tableBase({
    head: [[{ content: "TARİH", styles: { halign: "center" } }, "AÇIKLAMA", { content: "BORÇ", styles: { halign: "right" } }, { content: "ÖDENEN", styles: { halign: "right" } }, { content: "BAKİYE", styles: { halign: "right" } }]],
    body: body.length ? body : [[{ content: "Bu dönemde hareket bulunmuyor", colSpan: 5, styles: { halign: "center", textColor: SLATE } }]],
    startY: HEAD1 + 5 + rowH + 5,
    columnStyles: {
      0: { cellWidth: 19, halign: "center", textColor: TEXT, fontSize: 7 },
      1: { cellWidth: W - 19 - 27 - 27 - 29 },
      2: { cellWidth: 27, halign: "right", textColor: RED },
      3: { cellWidth: 27, halign: "right", textColor: GREEN },
      4: { cellWidth: 29, halign: "right", fontStyle: "bold", textColor: NAVY },
    },
    ...D.cellHooks(1, 7.6, "bold"),
  }));
  let y = pdf.lastAutoTable.finalY + 6;

  const cheques = stmt.pending_cheques || [];
  if (cheques.length) {
    y = D.ensure(y, 24) + 1;
    y = D.sectionTitle(y, "BEKLEYEN ÇEKLER", `${cheques.length} çek  ·  toplam ${money(cheques.reduce((s, ch) => s + Number(ch.amount || 0), 0))}`);
    autoTable(pdf, D.tableBase({
      head: [["VADE", "YÖN", "KİMDEN / KİME", "İLGİLİ FATURA", { content: "TUTAR", styles: { halign: "right" } }]],
      body: cheques.map((ch) => [ch.due_date ? fmtDate(ch.due_date) : "—", ch.direction === "gelen" ? "Alınan" : "Verilen", ch.from_whom || "—", ch.invoice_no || "—", money(ch.amount)]),
      startY: y,
      headStyles: { font: F.body, fontStyle: "bold", fillColor: BAND, textColor: NAVY, fontSize: 6.8, lineWidth: 0 },
      columnStyles: { 0: { cellWidth: 22 }, 1: { cellWidth: 20 }, 2: { cellWidth: W - 22 - 20 - 34 - 30 }, 3: { cellWidth: 34 }, 4: { cellWidth: 30, halign: "right", fontStyle: "bold", textColor: INK } },
    }));
    y = pdf.lastAutoTable.finalY + 6;
  }

  const tRows = [];
  if (opening) tRows.push(["DEVİR BAKİYESİ", money(opening)]);
  tRows.push(["TOPLAM BORÇ", money(stmt.total_debit), true]);
  tRows.push(["TOPLAM ÖDENEN", `− ${money(stmt.total_credit)}`, false, GREEN]);
  y = D.ensure(y, D.totalsHeight(tRows.length) + 2);
  T(F.body, "normal", 7, SLATE); pdf.text(`${(stmt.rows || []).length} hareket`, M, y + 4.8);
  if (showItems && (stmt.rows || []).some((r) => (r.items || []).length)) {
    T(F.body, "normal", 6.4, SLATE);
    pdf.text(pdf.splitTextToSize("Ürün dökümündeki tutarlar KDV hariç satır tutarlarıdır; Borç sütunu belge toplamıdır (KDV ve belge iskontosu dahil).", W - 92), M, y + 9.5, { lineHeightFactor: 1.4 });
  }
  y += D.totalsBox(y, tRows, Number(stmt.closing || 0)) + 6;
  D.badgesAtBottom(y);
  return D.finish();
}
